import React from 'react';

export default function PaginationOverflowItem(): JSX.Element {
  return (
    <li className="usa-pagination__item usa-pagination__overflow">
      <span> … </span>
    </li>
  );
}
